import { useEffect, useState } from "react";
import axios from "axios";

export default function LatestNews() {
    const [banner, setBanner] = useState(null);

    useEffect(() => {
        axios.get("/api/banner")
            .then(res => setBanner(res.data))
            .catch(() => setBanner(null));
    }, []);

    if (!banner) return null;

    // Медиа заполняет рамку целиком (кроп по object-cover), чтобы оба баннера
    // всегда были одной видимой ширины независимо от пропорций картинки
    const media = banner.media_type === "image"
        ? <img src="/api/banner/media" alt="banner" className="w-full h-full object-cover" />
        : <video src="/api/banner/media" autoPlay loop muted playsInline className="w-full h-full object-cover"></video>;

    // Рамка шириной до 1140px, соотношение сторон 935:60
    const frame = "block w-full max-w-[1140px] aspect-[935/60] overflow-hidden rounded-[4px]";

    return (
        <div className="w-full flex justify-center py-4 px-4 md:px-6">
            {banner.link ? (
                <a
                    href={banner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={frame}
                    onClick={() => navigator.sendBeacon('/api/click/banner/top')}
                >
                    {media}
                </a>
            ) : (
                <div className={frame}>
                    {media}
                </div>
            )}
        </div>
    );
}
